import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <footer style={styles.footer}>
      <div style={styles.inner}>
        <img src="/logo.png" alt="Moa" style={styles.brandImg} />
        <p style={styles.text}>{t('footer.cs')}: <a href="mailto:support@moashops.com" style={styles.email}>support@moashops.com</a></p>
        <nav style={styles.links}>
          <Link to="/support" style={styles.link}>{t('footer.partnership')}</Link>
          <span style={styles.divider}>|</span>
          <Link to="/privacy" style={styles.link}>{t('footer.privacy')}</Link>
          <span style={styles.divider}>|</span>
          <Link to="/terms" style={styles.link}>{t('footer.terms')}</Link>
        </nav>
        <p style={styles.copy}>{t('footer.rights')}</p>
      </div>
    </footer>
  );
};

const styles: Record<string, React.CSSProperties> = {
  footer: { background: '#f9f9f9', borderTop: '1px solid #eee', marginTop: 80 },
  inner: { maxWidth: 1200, margin: '0 auto', padding: '40px 20px', textAlign: 'center' },
  brand: { fontSize: 18, fontWeight: 700, color: '#b39ddb', marginBottom: 8 },
  brandImg: { height: 46, margin: '0 auto 8px', display: 'block' },
  text: { fontSize: 13, color: '#888', marginBottom: 12 },
  links: { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, marginBottom: 12 },
  link: { fontSize: 12, color: '#888', textDecoration: 'none' },
  divider: { fontSize: 12, color: '#ccc' },
  copy: { fontSize: 12, color: '#bbb' },
  email: { color: '#b39ddb', textDecoration: 'none' },
};

export default Footer;
